module.exports = __webpack_public_path__ + "img/h-page4-23.0bec2d92.png";